import * as Sentry from "@sentry/react";
import axios from "axios";

export function getGoogleClientId(): string {
  const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;

  if (!clientId) {
    console.warn("Google OAuth: Client ID is not configured.");
    Sentry.captureMessage("Google OAuth client ID missing", {
      level: "warning",
      tags: { source: "google-oauth.config" },
    });
    return "";
  }

  return clientId;
}

interface GoogleUserInfo {
  email: string;
  name: string;
}

export async function getGoogleUserInfo(
  accessToken: string,
): Promise<GoogleUserInfo> {
  try {
    const response = await axios.get(
      "https://www.googleapis.com/oauth2/v3/userinfo",
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    return {
      email: response.data.email,
      name: response.data.name,
    };
  } catch (error) {
    Sentry.captureException(error, {
      tags: { source: "google-oauth.userinfo" },
    });
    throw error;
  }
}
